export const mensaData = {
    "_NOTE": "English translations are not available/complete yet! We are working on it.",
    "announcements": [],
    "meals": [
      {
        "id": 91747,
        "date": "2024-12-20",
        "name": "Indisches Linsen-Dal | Basmatireis oder | Bulgur | Tagessalat",
        "name_en": "Indian dal with lentils | Basmati rice or | Bulgur | Salad of the day",
        "price": {
          "student": "2.50",
          "employee": "6.40",
          "guest": "7.50"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "686 kJ (164 kcal)",
            "fat": "6,4 g",
            "saturated_fatty_acids": "4,8 g",
            "carbohydrates": "22,0 g",
            "sugar": "1,8 g",
            "roughage": "0,0 g",
            "protein": "5,1 g",
            "salt": "0,8 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 10,
          "name": "Classic 1",
          "name_en": "Classic 1"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [
            {
              "id": "GL",
              "name": "enthält glutenhaltiges Getreide",
              "name_en": "containing cereal with gluten"
            },
            {
              "id": "SE",
              "name": "enthält Sesamsamen und Sesamsamenerzeugnisse",
              "name_en": "containing sesame seed and sesame seed products"
            },
            {
              "id": "GL1",
              "name": "GL enthält Weizen",
              "name_en": "containing wheat"
            }
          ],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93551,
        "date": "2024-12-20",
        "name": "Mediterrane Gemüsesuppe mit Bulgur",
        "name_en": "Mediterranean vegetable soup with bulgur",
        "price": {
          "student": "2.05",
          "employee": "3.75",
          "guest": "4.85"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "332 kJ (79 kcal)",
            "fat": "3,3 g",
            "saturated_fatty_acids": "0,6 g",
            "carbohydrates": "10,4 g",
            "sugar": "4,2 g",
            "roughage": "0,0 g",
            "protein": "2,5 g",
            "salt": "0,9 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 20,
          "name": "Classic 2",
          "name_en": "Classic 2"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [
            {
              "id": "GL",
              "name": "enthält glutenhaltiges Getreide",
              "name_en": "containing cereal with gluten"
            },
            {
              "id": "SL",
              "name": "enthält Sellerie und Sellerieerzeugnisse",
              "name_en": "containing celery and celery products"
            },
            {
              "id": "GL1",
              "name": "GL enthält Weizen",
              "name_en": "containing wheat"
            }
          ],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93556,
        "date": "2024-12-20",
        "name": "Hähnchengeschnetzeltes nach Gyros Art | Weißkrautsalat | Zaziki",
        "name_en": "Sliced Chicken \"Gyros Style\" | White cabbage salad | Tzatziki",
        "price": {
          "student": "3.90",
          "employee": "5.35",
          "guest": "6.45"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "578 kJ (138 kcal)",
            "fat": "7,7 g",
            "saturated_fatty_acids": "2,6 g",
            "carbohydrates": "4,7 g",
            "sugar": "3,8 g",
            "roughage": "0,0 g",
            "protein": "12,5 g",
            "salt": "1,1 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 20,
          "name": "Classic 2",
          "name_en": "Classic 2"
        },
        "tags": {
          "categories": [
            {
              "id": "GEFL",
              "name": "Geflügel",
              "name_en": "poultry"
            }
          ],
          "allergens": [
            {
              "id": "ML",
              "name": "enthält Milch u Milcherzeugnisse(inkl. Laktose)",
              "name_en": "containing milk and milk products (incl. lactose)"
            }
          ],
          "additives": [],
          "special": [
            {
              "id": "19",
              "name": "mit Flüssigwürze",
              "name_en": "with liquid seasoning"
            }
          ]
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93552,
        "date": "2024-12-20",
        "name": "Ofengemüse",
        "name_en": "Grilled vegetables",
        "price": {
          "student": "0.70",
          "employee": "1.30",
          "guest": "1.30"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "76 kJ (18 kcal)",
            "fat": "0,2 g",
            "saturated_fatty_acids": "0,1 g",
            "carbohydrates": "2,3 g",
            "sugar": "2,3 g",
            "roughage": "0,0 g",
            "protein": "1,4 g",
            "salt": "0,2 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 110,
          "name": "Gemüse",
          "name_en": "Veggie"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 91749,
        "date": "2024-12-20",
        "name": "Kartoffeln",
        "name_en": "Potatoes",
        "price": {
          "student": "0.45",
          "employee": "1.05",
          "guest": "1.05"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "70 kJ (17 kcal)",
            "fat": "0,1 g",
            "saturated_fatty_acids": "0,1 g",
            "carbohydrates": "14,8 g",
            "sugar": "1,7 g",
            "roughage": "1,5 g",
            "protein": "2,0 g",
            "salt": "0,7 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 160,
          "name": "Beilage",
          "name_en": "Side"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 91751,
        "date": "2024-12-20",
        "name": "Pommes frites",
        "name_en": "French fries",
        "price": {
          "student": "0.80",
          "employee": "1.40",
          "guest": "1.40"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "865 kJ (207 kcal)",
            "fat": "13,2 g",
            "saturated_fatty_acids": "2,6 g",
            "carbohydrates": "19,1 g",
            "sugar": "0,5 g",
            "roughage": null,
            "protein": "2,3 g",
            "salt": "0,1 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 160,
          "name": "Beilage",
          "name_en": "Side"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [],
          "additives": [
            {
              "id": "3",
              "name": "mit Antioxidationsmittel",
              "name_en": "with antioxidant"
            }
          ],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 91752,
        "date": "2024-12-20",
        "name": "Basmatireis",
        "name_en": "Basmati rice",
        "price": {
          "student": "0.45",
          "employee": "1.05",
          "guest": "1.05"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "585 kJ (140 kcal)",
            "fat": "0,4 g",
            "saturated_fatty_acids": "0,1 g",
            "carbohydrates": "30,5 g",
            "sugar": "0,1 g",
            "roughage": null,
            "protein": "2,9 g",
            "salt": "0,8 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 160,
          "name": "Beilage",
          "name_en": "Side"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93544,
        "date": "2024-12-20",
        "name": "Bulgur",
        "name_en": "Bulgur",
        "price": {
          "student": "0.45",
          "employee": "1.05",
          "guest": "1.05"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "379 kJ (91 kcal)",
            "fat": "0,5 g",
            "saturated_fatty_acids": "0,1 g",
            "carbohydrates": "22,1 g",
            "sugar": "2,7 g",
            "roughage": "0,0 g",
            "protein": "3,7 g",
            "salt": "0,4 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 160,
          "name": "Beilage",
          "name_en": "Side"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [
            {
              "id": "GL",
              "name": "enthält glutenhaltiges Getreide",
              "name_en": "containing cereal with gluten"
            },
            {
              "id": "GL1",
              "name": "GL enthält Weizen",
              "name_en": "containing wheat"
            }
          ],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93554,
        "date": "2024-12-20",
        "name": "Wedges",
        "name_en": "Wedges",
        "price": {
          "student": "0.80",
          "employee": "1.40",
          "guest": "1.40"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "836 kJ (200 kcal)",
            "fat": "11,8 g",
            "saturated_fatty_acids": "1,0 g",
            "carbohydrates": "20,0 g",
            "sugar": "1,4 g",
            "roughage": "2,3 g",
            "protein": "2,3 g",
            "salt": "0,6 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 160,
          "name": "Beilage",
          "name_en": "Side"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGA",
              "name": "Vegan",
              "name_en": "vegan"
            }
          ],
          "allergens": [],
          "additives": [
            {
              "id": "3",
              "name": "mit Antioxidationsmittel",
              "name_en": "with antioxidant"
            }
          ],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      },
      {
        "id": 93549,
        "date": "2024-12-20",
        "name": "Waldfruchtjoghurt",
        "name_en": "Yogurt with mixed berries",
        "price": {
          "student": "0.95",
          "employee": "1.20",
          "guest": "1.20"
        },
        "nutritional_values": {
          "_NOTE": "WARNING: These fields currently contain incorrect values. Do not use them yet!",
          "per_100_grams": {
            "caloric_value": "314 kJ (75 kcal)",
            "fat": "3,4 g",
            "saturated_fatty_acids": "2,2 g",
            "carbohydrates": "7,2 g",
            "sugar": "7,0 g",
            "roughage": "0,0 g",
            "protein": "3,6 g",
            "salt": "0,1 g"
          }
        },
        "location": {
          "id": 102,
          "name": "Mensa 1 TU Braunschweig",
          "address": {
            "line1": "Mensa 1 TU Braunschweig",
            "line2": null,
            "street": "Katharinenstraße 1",
            "zip": "38106",
            "city": "Braunschweig"
          },
          "opening_hours": [
            {
              "time": "noon",
              "start_day": 1,
              "end_day": 4,
              "start_time": "11:20:00",
              "end_time": "14:15:00"
            },
            {
              "time": "noon",
              "start_day": 5,
              "end_day": 5,
              "start_time": "11:20:00",
              "end_time": "14:00:00"
            },
            {
              "time": "evening",
              "start_day": 1,
              "end_day": 4,
              "start_time": "16:00:00",
              "end_time": "19:30:00"
            }
          ]
        },
        "time": "noon",
        "lane": {
          "id": 90,
          "name": "Dessert",
          "name_en": "Dessert"
        },
        "tags": {
          "categories": [
            {
              "id": "VEGT",
              "name": "Vegetarisch",
              "name_en": "vegetarian"
            }
          ],
          "allergens": [
            {
              "id": "ML",
              "name": "enthält Milch u Milcherzeugnisse(inkl. Laktose)",
              "name_en": "containing milk and milk products (incl. lactose)"
            }
          ],
          "additives": [],
          "special": []
        },
        "special_tags": [
          "Deprecated. Use tags→special instead."
        ]
      }
    ]
  }

export const departuresData = [
    {
        line: "2",
        destination: "Heidberg",
        track: "Gleis 2",
        actualTime: "16:54",
        scheduledTime: "16:51"
    },
    {
        line: "2",
        destination: "Siegfriedviertel",
        track: "Gleis 2",
        actualTime: "16:56",
        scheduledTime: "16:53"
    },
    {
        line: "1",
        destination: "Stöckheim",
        track: "Gleis 1",
        actualTime: "17:00",
        scheduledTime: "16:59"
    },
    {
        line: "1",
        destination: "Wenden",
        track: "Gleis 1",
        actualTime: "17:01",
        scheduledTime: "17:01"
    }
]